import React, { createContext } from 'react';

const globalContext = createContext({});

export { globalContext };
